import Route from '@ember/routing/route';

export default class AuthOrdersRoute extends Route {}
